import { Navigate, useLocation } from 'react-router-dom';
import { useAgentAuth } from '../../contexts/AgentAuthContext';

/**
 * Protects /agents/* routes: requires Google sign-in and allowlist.
 * Wrap AgentsLayout and all tool routes with this.
 */
export default function AgentsGuard({ children }) {
  const { loading, user, allowed, allowlistChecked } = useAgentAuth();
  const location = useLocation();

  if (loading || !allowlistChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-muted/30">
        <p className="text-muted-foreground">Loading…</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/agents/login" state={{ from: location }} replace />;
  }

  if (!allowed) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-muted/30">
        <div className="max-w-md text-center">
          <h1 className="text-xl font-semibold text-foreground mb-2">Access not allowed</h1>
          <p className="text-muted-foreground mb-4">
            Your email is not on the agent allowlist. Contact your administrator to get access.
          </p>
          <button
            onClick={() => window.history.back()}
            className="text-primary hover:underline"
          >
            Go back
          </button>
        </div>
      </div>
    );
  }

  return children;
}
